/**
 * Wisdom proverbs in 13 languages for the Matrix screensaver.
 * Each rain column picks one quote; its characters fall top → bottom,
 * so a reader who knows the language can read the proverb vertically.
 *
 * Languages (as agreed with the operator): English, Arabic, Uzbek,
 * Chinese, Japanese, Korean, Russian, Hindi, Spanish, French, German,
 * Turkish, Greek.
 */
export const WISDOM_QUOTES = [
  {
    lang: 'en',
    name: 'English',
    quotes: [
      'Knowledge is power',
      'Still waters run deep',
      'Fortune favours the bold',
      'Trust, but verify',
      'Slow and steady wins the race',
    ],
  },
  {
    lang: 'ar',
    name: 'Arabic',
    quotes: [
      'العلم نور',                       // Knowledge is light
      'الصبر مفتاح الفرج',               // Patience is the key to relief
      'خير الكلام ما قل ودل',            // The best speech is brief and clear
      'من جد وجد',                       // Who strives, finds
    ],
  },
  {
    lang: 'uz',
    name: 'Uzbek',
    quotes: [
      'Bilim — bebaho boylik',           // Knowledge is priceless wealth
      'Sabr tagi — oltin',               // At the bottom of patience lies gold
      'Harakatda barakat',               // In motion there is blessing
      "Ustoz — otangdek ulug'",          // A teacher is as great as your father
    ],
  },
  {
    lang: 'zh',
    name: 'Chinese',
    quotes: [
      '千里之行始于足下',                 // A 1000-mile journey starts with one step
      '水滴石穿',                         // Dripping water pierces stone
      '学而不思则罔',                     // Learning without thought is lost
      '知己知彼百战不殆',                 // Know yourself and your opponent
    ],
  },
  {
    lang: 'ja',
    name: 'Japanese',
    quotes: [
      '七転び八起き',                     // Fall seven times, rise eight
      '急がば回れ',                       // If you hurry, take the long way
      '継続は力なり',                     // Persistence is power
      '塵も積もれば山となる',             // Even dust piles into a mountain
    ],
  },
  {
    lang: 'ko',
    name: 'Korean',
    quotes: [
      '고생 끝에 낙이 온다',              // Joy comes after hardship
      '시작이 반이다',                    // Starting is half the task
      '티끌 모아 태산',                   // Dust gathered makes a mountain
      '백지장도 맞들면 낫다',             // Even paper is lighter lifted together
    ],
  },
  {
    lang: 'ru',
    name: 'Russian',
    quotes: [
      'Тише едешь — дальше будешь',      // Ride slower, get further
      'Век живи — век учись',            // Live a century, learn a century
      'Терпение и труд всё перетрут',    // Patience and work grind through all
      'Слово — серебро, молчание — золото', // Speech is silver, silence gold
    ],
  },
  {
    lang: 'hi',
    name: 'Hindi',
    quotes: [
      'ज्ञान ही शक्ति है',                 // Knowledge itself is power
      'बूंद बूंद से सागर बनता है',          // Drop by drop an ocean forms
      'जैसा बोओगे वैसा काटोगे',            // As you sow, so shall you reap
      'सब्र का फल मीठा होता है',           // The fruit of patience is sweet
    ],
  },
  {
    lang: 'es',
    name: 'Spanish',
    quotes: [
      'Más vale tarde que nunca',        // Better late than never
      'El saber no ocupa lugar',         // Knowledge takes no space
      'Quien mucho abarca poco aprieta', // Grasp much, hold little
      'No hay mal que por bien no venga',// Every cloud has a silver lining
    ],
  },
  {
    lang: 'fr',
    name: 'French',
    quotes: [
      "Petit à petit l'oiseau fait son nid", // Little by little the bird builds its nest
      "Vouloir c'est pouvoir",           // To want is to be able
      'La nuit porte conseil',           // The night brings counsel
      "C'est en forgeant qu'on devient forgeron", // Practice makes the smith
    ],
  },
  {
    lang: 'de',
    name: 'German',
    quotes: [
      'Wissen ist Macht',                // Knowledge is power
      'Übung macht den Meister',         // Practice makes the master
      'Aller Anfang ist schwer',         // All beginnings are hard
      'Wer wagt, gewinnt',               // Who dares, wins
    ],
  },
  {
    lang: 'tr',
    name: 'Turkish',
    quotes: [
      'Damlaya damlaya göl olur',        // Drop by drop a lake forms
      'Sabreden derviş muradına ermiş',  // The patient dervish reached his goal
      'Bilgi güçtür',                    // Knowledge is power
      'Bir elin nesi var iki elin sesi var', // Two hands make a sound
    ],
  },
  {
    lang: 'el',
    name: 'Greek',
    quotes: [
      'Γνώθι σεαυτόν',                   // Know thyself
      'Σπεύδε βραδέως',                  // Hasten slowly
      'Η αρχή είναι το ήμισυ του παντός', // The beginning is half of everything
      'Ουδέν κακόν αμιγές καλού',        // No evil without some good
    ],
  },
];

/** Flat pool of { lang, text } — what the rain columns sample from. */
export const QUOTE_POOL = WISDOM_QUOTES.flatMap((l) =>
  l.quotes.map((q) => ({ lang: l.lang, text: q }))
);
